import React from 'react';

import { TCard } from '@/services/requests/Recommendation/types/template1';

import { clearHtmlTags } from '@/helpers/HtmlHelper/clearHtmlTags';

type TProps = {
  data: TCard;
};

export const CardOffer = ({ data }: TProps) => {
  const { id, icon, title } = data;

  return (
    <div className="vitrine-template1__cardoffer" key={id} data-id={id}>
      <img
        className="vitrine-template1__cardoffer__icon"
        src={icon}
        alt={clearHtmlTags(title)}
      />
      <span
        className="vitrine-template1__cardoffer__title"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: title }}
      />
    </div>
  );
};
